<template>
    <div class="pageoader">
		<img src="../../../../static/website/images/loader.gif" alt="Icon">
    </div>
</template>

<script>
export default {
    name:'loader'
}
</script>


// WEBPACK FOOTER //
// src/components/website/shared/loader.vue